import React, { useState } from 'react';
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import moment from 'moment';
import { Button } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { ReportService } from '../../business/ReportService';

const ExportToExcel = ({ api, filters, fileName, texto }) => {
  const fileType =
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = (apiData, fileName) => {
    if (!apiData || apiData.length === 0) return;

    // Convertir fechas
    const formattedData = apiData.map(row => {
      const newRow = {};
      Object.keys(row).forEach(key => {
        let value = row[key];
        if (moment(value, moment.ISO_8601, true).isValid()) {
          if (key === 'FECHA CUOTA' || key === 'FECHA DEVOLUCION') {
            value = moment(value).format("YYYY-MM-DD");
          }
        }
        newRow[key] = value;
      });
      return newRow;
    });

    const ws = XLSX.utils.json_to_sheet(formattedData);

    // Estilo cabecera con relleno de color
    const range = XLSX.utils.decode_range(ws['!ref']);
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      if (ws[cellAddress]) {
        ws[cellAddress].s = {
          font: { bold: true, color: { rgb: "FFFFFF" } },
          fill: { fgColor: { rgb: "4F81BD" } },
          alignment: { horizontal: "center", vertical: "center" }
        };
      }
    }

    // Autoajustar columnas
    const wscols = Object.keys(formattedData[0]).map(key => {
      const maxLength = formattedData.reduce((max, row) => {
        const value = row[key] ? row[key].toString() : "";
        return Math.max(max, value.length);
      }, key.length);
      return { wch: maxLength + 2 };
    });
    ws['!cols'] = wscols;

    // Formatear celdas con montos a dos decimales
    const headers = Object.keys(formattedData[0]);
    const rangeCells = XLSX.utils.decode_range(ws['!ref']);
    for (let R = rangeCells.s.r + 1; R <= rangeCells.e.r; ++R) {
      for (let C = rangeCells.s.c; C <= rangeCells.e.c; ++C) {
        const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });
        const cell = ws[cellAddress];

        const headerName = headers[C];

        if (
          cell &&
          typeof cell.v === 'number' &&
          ['MONTO DE DEVOLUCION', 'MONTO DE CUOTA', 'PAGO CUPON', 'RETENCION'].includes(headerName)
        ) {
          cell.z = '0.00';
        }
      }
    }

    // Filtros
    ws['!autofilter'] = { ref: ws['!ref'] };

    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, {
      bookType: "xlsx",
      type: "array",
      cellStyles: true,
    });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };



  const [loading, setLoading] = useState(false);
  const [filter] = useState(filters);

  const getQuotas = async () => {
    const accountInstance = ReportService.getInstance();
    setLoading(true);
    try {
      const data = await accountInstance.getQuotas(filter);
      if (data) {
        const processedData = data.map((col) => ({
          "PRIMER APELLIDO": col.lastName,
          "SEGUNDO APELLIDO": col.secondLastname,
          "NOMBRES": col.names,
          "TIPO DE DOCUMENTO": col.docType,
          "NRO DE DOCUMENTO": col.docNumber,
          "PRODUCTO": col.product,
          "FECHA CUOTA": col.quotaDate,
          "FECHA DEVOLUCION": col.endDate,
          "MONTO DE DEVOLUCION": col.returnAmount,
          "MONTO DE CUOTA": col.amount,
          "PAGO CUPON": col.coupon,
          "RETENCION": col.retention,
          "BANCO": col.bank,
          "NUMERO DE CUENTA": col.bankAccount,
          "CCI": col.cci,
          "ASESOR": col.advisor,
        }));
        exportToCSV(processedData, fileName);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const getData = (api) => {
    switch (api) {
      case 'get-quotas':
        getQuotas();
        break;
      default:
        console.warn("API no soportada:", api);
    }
  };

  return (
    <Button onClick={() => getData(api)} disabled={loading}>
      <FileDownloadOutlinedIcon /> {texto}
    </Button>
  );
};

export default ExportToExcel;
